/**
 * Tracking eventi di gioco → API Lupo Game su vibecanyon.com. I dati si vedono
 * nella dashboard https://vibecanyon.com/admin. Vedi TRACKING_INTEGRATION.md.
 *
 * Client-side, ZERO dipendenze, NON bloccante (try/catch ovunque: non deve MAI
 * rompere il gioco). Invio con `sendBeacon` + `text/plain`: robusto (nessun
 * preflight, e `game_end` parte anche mentre la pagina si chiude). L'endpoint
 * abilita comunque CORS (`Access-Control-Allow-Origin: *`) per il fallback fetch.
 */

const TRACK_URL = 'https://vibecanyon.com/api/track';
const GAME = 'tilt'; // slug ufficiale di questo gioco (non cambiare)

type Meta = Record<string, unknown>;

function makeSessionId(): string {
  try {
    if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  } catch {
    /* crypto non disponibile */
  }
  // Fuori dal motore deterministico: Date.now/Math.random qui sono leciti.
  return `${GAME}-${Date.now()}-${Math.floor(Math.random() * 1e6)}`;
}

const SESSION_ID = makeSessionId();

export function track(event: string, metadata?: Meta): void {
  try {
    const payload: Meta = { event, game: GAME, sessionId: SESSION_ID };
    if (metadata) payload.metadata = metadata;
    const body = JSON.stringify(payload);
    const blob = new Blob([body], { type: 'text/plain' });
    // sendBeacon: fire-and-forget, sopravvive al cambio pagina.
    if (navigator.sendBeacon && navigator.sendBeacon(TRACK_URL, blob)) return;
    // fallback non bloccante (CORS abilitato sull'endpoint).
    void fetch(TRACK_URL, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain' },
      body,
    }).catch(() => {});
  } catch {
    /* mai rompere il gioco */
  }
}

export const tracking = {
  /** Sessione avviata (gioco caricato e giocabile). Una volta al boot. */
  gameStart: (): void => track('game_start'),
  /** Uscita / chiusura pagina. */
  gameEnd: (metadata?: Meta): void => track('game_end', metadata),
  /** Una run è partita (dopo la scelta del personaggio): numeratore del funnel. */
  runStart: (metadata: Meta): void => track('run_start', metadata),
  /** Round superato: la profondità della run è la metrica di bilanciamento. */
  roundCleared: (round: number): void => track('level_completed', { level: round }),
  /**
   * Fine run (over o vittoria): il "punteggio" di TILT è la mano migliore.
   * metadata: { round, won, character }.
   */
  runEnd: (bestHand: number, metadata: Meta): void =>
    track('score_recorded', { score: bestHand, ...metadata }),
};
